import * as React from "react"
import { SafeAreaView, StyleProp, ViewStyle } from "react-native"
import { observer } from "mobx-react-lite"
import { color } from "../../theme"
import { Text } from "../text/text"
import { View } from "native-base"
import { useStores } from "../../models"

export interface OfflineModeIndicatorProps {
  /**
   * An optional style override useful for padding & margin.
   */
  style?: StyleProp<ViewStyle>
}

/**
 * Describe your component here
 */
export const OfflineModeIndicator = observer(function OfflineModeIndicator(props: OfflineModeIndicatorProps) {
  const { appStore: { isOffline } } = useStores()

  if (!isOffline) return null;
  return (
    <View backgroundColor={color.palette.gray600} alignItems="center" py="4px">
      <Text tx="homeScreen.offline" preset="title4" color={color.palette.white} />
      {/* <SafeAreaView /> */}
    </View>
  )
})
